import React from 'react'
import styled from '@emotion/styled'
import { Checkbox } from 'stylist'
import QuotaWrapper from './QuotaWrapper'
import Container from 'components/Container'
import { CenteredCol, GrowCol } from 'components/Col'
import { Slate, Bold } from 'components/Text'
import { range } from 'utils'
import size from 'lodash/size'
/*
Example of the form elements this component is responsible for
{
  ...
    questions: {
      gender: [0, 1]
    },
    quotas: {
      gender0: {
        limit: 50,
        questions: {
          gender: [0]
        }
      },
      gender1: {
        limit: 50,
        questions: {
          gender: [1]
        }
      }
    }
  ...
}
 */

const PaddedCol = styled(CenteredCol)`
  margin-right: 10%;
`

class MultiSelect extends React.Component {
  constructor(props) {
    super(props)
    this.quotaSetters = {}
    this.selected = null
    this.setSelected = null
  }

  handleChange(index, turnOn) {
    this.handleChangeMultiple([index], turnOn)
  }

  handleChangeMultiple(indexes, turnOn) {
    const { name, selected, setSelected } = this.props
    if (turnOn) {
      const newSelections = indexes.filter(x => !selected.includes(x))
      setSelected([...selected, ...newSelections])
      newSelections.forEach(index =>
        this.quotaSetters[index]({
          limit: '',
          questions: {
            [name]: [index]
          }
        })
      )
    } else {
      setSelected(selected.filter(x => !indexes.includes(x)))
      indexes.forEach(index => this.quotaSetters[index](undefined))
    }
  }

  render() {
    const { name, options, selected, translatedOptions } = this.props
    return (
      <QuotaWrapper
        name={name}
        qualOptions={options}
        header={() => (
          <Container>
            <PaddedCol>
              <Checkbox
                id={name}
                onChange={e =>
                  this.handleChangeMultiple(
                    range(0, options.length - 1),
                    e.target.checked
                  )
                }
                checked={selected && selected.length === options.length}
              />
            </PaddedCol>
            <GrowCol>
              <Bold>
                <Slate>Answers</Slate>
              </Bold>
            </GrowCol>
          </Container>
        )}
        row={(option, index, setQuota) => {
          this.quotaSetters[index] = setQuota
          return (
            <Container>
              <PaddedCol>
                <Checkbox
                  id={`${name}-${option}`}
                  onChange={e => this.handleChange(index, e.target.checked)}
                  checked={selected && selected.includes(index)}
                />
              </PaddedCol>
              <GrowCol>
                {size(translatedOptions) ? translatedOptions[index] : option}
              </GrowCol>
            </Container>
          )
        }}
      />
    )
  }
}

export default MultiSelect



// WEBPACK FOOTER //
// ./src/routes/estimate/subroutes/form/MultiSelect.js